import React from "react";
import { graphql } from "gatsby";
import Seo from "../components/Seo";
import Layout from "../layouts/sample";

import NewIntro from "../components/front/NewIntro";
import { SubscribeFormNew } from "../components/global/SubscribeFormNew";
import { Clients } from "../components/front/Clients";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { StatsNew } from "../components/front/StatsNew";
import { Value } from "../components/front/Value";
import OpportunitiesSection from "../components/front/Opportunities";
import JoinVideo from "../components/front/JoinVideo";
import SubscribeCta from "../components/front/SubscribeCta";

const IndexPage = (props) => {


  const acf = props.data.page.template?.homePageACF || {};
  const translations = props?.data?.page?.translations || {};
  const stats = props?.data?.page?.template?.statsACF?.numbers || [];
  const oppItems = Array.isArray(acf.opportunities) ? acf.opportunities : [];

  return (
    <Layout translations={translations}>
    <NewIntro data={acf.newintro} />
    <Value data={{ items: acf.items || [] }} />
    <StatsNew data={acf.intro} stats={stats} numbers={acf.explore} />
    <OpportunitiesSection data={{ items: oppItems }} />
    <Clients />
    <JoinVideo data={acf.join || {}} />
    <SubscribeCta data={acf.newsletter || {}} />
    </Layout>
  );
};

export default IndexPage;


export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    page: wpPage(language: { slug: { eq: $language } }, template: { templateName: { eq: "Front Page" } }) {
      title
      seo {
        title
        metaDesc
        opengraphDescription
        opengraphTitle
      }
      translations {
        slug
        isFrontPage
      }
      template {
        ... on WpTemplate_FrontPage {
          statsACF {
            numbers {
              label
              title
              value
              source
              color
            }
          }
          homePageACF {
            newintro {
              title1
              title2
              subtitle
              trustedtext
            }
            items {
              url
              title
              label
              description
            }
            opportunities {
              bgclass
              labelnumber
              labeltext
              title
              description
              cta {
                url
                title
                target
              }
              }
            newsletter {
            number
            subtitle
            title
            text
            bgclass
            }
            join {
              bgclass
              labelnumber
              labeltext
              title
              description
              cta {
                url
                title
                target
              }
          }
          }
        }
      }
    }
  }
`;




export const Head = (props) => {
  const seo = props.data.page?.seo || {};
  return <Seo title={seo?.title} description={seo?.metaDesc} />;
};
